import React from 'react'
import SessionsTable from '../tables/SessionsTable';

const Sessions = () => {
  return (
    <SessionsTable/>
  )
}

export default Sessions;